import { Trans } from '@mc/i18n'
import { paths } from '@mc/paths'
import { getNumberOfInstructors } from '@mc/instructors'
import { FreeTrial, NoFreeTrial } from '@mc/free-trial'

import i18nInstance from 'i18n/i18nInstance'

import { Section } from './types'

const t = i18nInstance.getFixedT(null, '@mc/next')

type GetFreeTrialSectionProps = {
  trial: FreeTrial | NoFreeTrial
}

export const getFreeTrialSection: (
  props: GetFreeTrialSectionProps,
) => Section = ({ trial }: GetFreeTrialSectionProps) => ({
  title: t('faq.freeTrial.title'),
  questions: [
    {
      uuid: 'faq.freeTrial.question1',
      title: t('faq.freeTrial.question1'),
      answer: (
        <Trans
          i18nKey='faq.freeTrial.answer1'
          values={{
            instructorCount: getNumberOfInstructors(),
            duration: trial.strings.duration,
          }}
          ns='@mc/next'
        >
          <p className='mc-opacity--hinted' />
        </Trans>
      ),
    },
    {
      uuid: 'faq.freeTrial.question2',
      title: t('faq.freeTrial.question2'),
      answer: (
        <Trans
          i18nKey='faq.freeTrial.answer2'
          ns='@mc/next'
          values={{
            campaign: 'Klarna', // TODO: Get this value from trial https://masterclass-dev.atlassian.net/browse/PEN-5512,
            duration: trial.strings.durationShort,
          }}
        >
          <p className='mc-opacity--hinted' />
          <br />
          <p className='mc-opacity--hinted'>
            {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
            <a
              href={paths.freeTrialTermsPath}
              className='mc-text--link'
              target='_blank'
              rel='noopener noreferrer'
              data-testid='guest-pass-terms-link'
            />
          </p>
        </Trans>
      ),
    },
  ],
})
